<template>
    <div>
        <div layout="column" layout-align="start start" class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc">{{$t('params.rds')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width">
                <v-select
                    :label="$t('filters.status')"
                    :hint="$t('filters.status_hint')"
                    persistent-hint
                    solo v-model="filters.is_enabled"
                    :items="listStatus"
                    @change="fetch"
                    class="mr5-pc width-100-mobile"
                >
                </v-select>
                <v-text-field solo :label="$t('filters.keywords')" :hint="$t('filters.rds_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch" class="ml5-pc mr5-pc width-100-mobile"></v-text-field>
                <v-btn depressed class="ml5-pc" color="secondary" @click="fetch" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
        <div layout="column" layout-align="start start" class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white">
            <div class="font-weight-bold">
                <span class="secondary--text">{{rds.length}}</span>&nbsp;
                <span v-if="rds.length > 1">
                    <span class="text-lowercase">{{$t('params.rds')}}</span>
                    {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                </span>
                <span v-else>
                    <span class="text-lowercase">{{$t('params.rd')}}</span>
                    {{$t('filters.match')}} {{$t('filters.criteria')}}
                </span>
            </div>

            <div class="mt-1">
                <v-btn class="ml-0" flat outline color="secondary" :to="{name: 'admin-settings-regional-directorates-edit', params: {id: 'new'}}">
                    <span style="text-transform: none">{{$t('params.add_rd_btn')}}</span>
                </v-btn>
            </div>

            <v-data-table :headers="headers" :items="rds"  :pagination.sync="pagination" class="full-width hidden-sm-and-down">
                <template slot="items" slot-scope="{ item }">
                    <td><v-icon :color="item.is_enabled ? 'success' : 'error'">mdi-checkbox-blank-circle-outline</v-icon></td>
                    <td>{{ i18n(item.label) }}</td>
                    <td><v-icon v-if="item.translated" color="success">mdi-check</v-icon><v-icon v-else color="warning">mdi-alert</v-icon></td>
                    <td layout="row">
                        <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-regional-directorates-edit', params: {id: item.id}}">
                            <v-icon color="secondary">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                            <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>

            <div class="hidden-md-and-up full-width pa-2" layout="column">
                <div layout="row" layout-align="start center" v-for="item in rds" class="full-width mb-3" :key="item.id">
                    <v-avatar class="mr-3 ml-1">
                        <v-icon :class="{'circle-container': true, 'success': item.is_enabled, 'error': !item.is_enabled}" color="white">mdi-map-marker</v-icon>
                    </v-avatar>
                    <div layout="column" flex>
                        <div layout="row" class="font-weight-bold">
                            {{ i18n(item.label) }}
                        </div>
                        <div layout="row" layout-align="start center">
                            <v-icon v-if="item.translated" color="success">mdi-check</v-icon>
                            <v-icon v-else color="error">mdi-alert</v-icon>
                            &nbsp;{{$t('params.translations')}}
                        </div>
                    </div>
                    <div layout="column">
                        <div layout="row" layout-align="start center">
                            <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-regional-directorates-edit', params: {id: item.id}}"><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                            <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                                <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                pagination: {
                    rowsPerPage: 10,
                    descending: 0,
                    sortBy: "`label.${_locale}`",
                },
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sortBy: 'label'
                },
                rds: [],
                displayFilters: false
            }
        },
        mounted () {
            this.fetch();
            this.pagination.sortBy = 'label.' + this._locale;
        },
        methods: {
            fetch () {
                Params.getList('regional-directorates', this.filters).then(res => {
                    this.rds = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null, is_enabled: null, sortBy: 'label'};
                this.fetch();
            },

            toggle (item) {
                if (item.is_enabled) {
                    Params.disable('regional-directorates', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('params.rd_disable'))
                    })
                } else {
                    Params.enable('regional-directorates', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('params.rd_enable'))
                    })
                }
            }
        },
        computed: {
            headers () {
                return [
                    { text: this.$t('filters.status'), value: 'is_enabled', width: "50px" },
                    { text: this.$t('params.rd'), value: 'label.' + this._locale },
                    { text: this.$t('params.translations'), value: 'translated' },
                    { text: this.$t('_.actions'), sortable: false, width: "80px" }
                ]
            },
            listStatus () {
                return [
                    { value: null, text: this.$t('filters.status_all') },
                    { value: 1, text: this.$t('filters.status_enabled') },
                    { value: 0, text: this.$t('filters.status_disabled') }
                ]
            }
        }
    }
</script>